import {
  Box,
  Button,
  Collapse,
  Flex,
  Rotate,
  SearchInput,
  FilterListOutlinedIcon,
  ExpandMoreRoundedIcon,
  type SearchInputProps,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useAdminExamLocationListSearchParams } from '../../hooks';
import { AdminExamLocationFilterSection } from '../admin-exam-location-filter-section';

export default function AdminExamLocationSearchFilter() {
  const [isExpand, { toggle: toggleExpand }] = useDisclosure(false);
  const [{ locationName }, { changeLocationName }] = useAdminExamLocationListSearchParams();

  const handleSearchInputChange: SearchInputProps['onChange'] = (value) => {
    changeLocationName(value);
  };

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ width: 300 }}>
          <SearchInput
            defaultValue={locationName ?? undefined}
            placeholder='ค้นหาชื่อสถานที่/หน่วยงาน...'
            onChange={handleSearchInputChange}
          />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          size='large'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggleExpand}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <AdminExamLocationFilterSection />
      </Collapse>
    </>
  );
}
